module.exports = __webpack_public_path__ + "img/sprinkle-15.140f8b75.webp";